import React, { useEffect, useState } from "react"
import TableCustom from "src/components/Table/CustomTable"
import dayjs from "dayjs"
import ReportsService from "src/services/ReportService"
import FilterCustom from "./Filter"
import ViewSaleDetailModal from "../Modal/DetailModal"
import ViewSimDetailModal from "../Modal/ViewSimDetailModal"
import TabsCustom from "src/components/TabsCustom"
import { StyleTabsCustom } from "src/components/TabsCustom/styled"
import ReportPoolDataService from "src/services/ReportPoolDataService"
import { COLOR_SUMMARY, getDiscountTypeName, STATUS } from "src/constants/constants"


function ListSale({
  refresh,
  setRefresh,
  permissions,
  setParentFilter,
  setKeywordExcel,
}) {
  const [dataSource, setDataSource] = useState([])
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  })
  const [loading, setLoading] = useState(false)
  const [summary, setSummary] = useState({})
  const [filter, setFilter] = useState({})
  const [keyword, setKeyword] = useState("")
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [isSimModalOpen, setIsSimModalOpen] = useState(false)
  const [tabStatus, setTabStatus] = useState("")
  const [activeKey, setActiveKey] = useState("all")

  const fetchData = async (pagination, filter, keyword, tab) => {
    setLoading(true)
    setParentFilter(filter)
    setKeywordExcel(keyword)
    try {
      const res = await ReportPoolDataService.getReportPackageOrderM2M({
        page: pagination.current,
        per_page: pagination.pageSize,
        status: tab,
        filter: {
          ...filter,
        },
        keyword,
      })

      if (res?.success?.data) {
        console.log("API trả về:", res.success.data)

        const formatted = res.success.data.map((item, index) => ({
          ...item,
          key: item.ID || index,
          sale_price: Number(item.sale_price || 0).toLocaleString(),
          price_discount: Number(item.price_discount || 0).toLocaleString(),
          data_volume_gb: item.package_excels?.data_volume_gb || "",
        }))

        setDataSource(formatted)
        setSummary(res.success.amount)
        setPagination({
          ...pagination,
          total: res.success.total,
        })
      }
    } catch (err) {
      console.error("Lỗi:", err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData(pagination, filter, keyword, tabStatus)
  }, [pagination.current, pagination.pageSize])
  useEffect(() => {
    if (pagination.current !== 1) {
      setPagination(prev => ({
        ...prev,
        current: 1,
      }))
    } else {
      if (pagination.total !== undefined) {
        fetchData(pagination, filter, keyword, tabStatus)
      }
    }
  }, [refresh, filter, keyword, tabStatus])
  useEffect(() => {
    setPagination({
      ...pagination,
      current: 1,
    })
  }, [filter])


  const Tabs = {
    all: {
      type: "all",
      name: "Tất cả",
      status: "",
    },
    pending: {
      type: "pending",
      name: "Chờ duyệt",
      status: 1,
    },
    success: {
      type: "success",
      name: "Đã duyệt",
      status: 2,
    },
    reject: {
      type: "reject",
      name: "Từ chối",
      status: 3,
    },
  }

  const columns = [
    { title: "Mã đơn hàng", dataIndex: "order_code", align: "center" },
    {
      title: "Khách hàng",
      dataIndex: "customer",
      key: "customer",
      render: customer => customer?.fullname || "",
      align: "center",
    },
    { title: "Thuê bao chủ", dataIndex: "parent_phone", align: "center" },
    { title: "Mã gói cước", dataIndex: "package_code", align: "center" },
    { title: "Loại gói cước", dataIndex: "package_type", align: "center" },
    {
      title: "Dung lượng",
      dataIndex: "data_volume_gb",
      align: "center",
      render: value => value ? value + " GB" : ""
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      align: "center",
      render: value => {
        const status = STATUS[value];
        if (!status) return "";
        const { label, color } = status;
        return <span style={{ color, fontWeight: "bold" }}>{label}</span>;
      }
    },
    // { title: "Người tạo", dataIndex: "creator_name", align: "center" },
    // {
    //   title: "Tổng tiền trước chiết khấu",
    //   dataIndex: "sale_price",
    //   key: "sale_price",
    //   align: "right",
    //   onHeaderCell: () => ({
    //     style: { textAlign: "center" },
    //   }),
    // },
    // { title: "Loại chiết khấu", dataIndex: "discount_type", align: "center", render: value => getDiscountTypeName(value) },
    // { title: "Chiết khấu (%)", dataIndex: "discount_value", align: "center", render: value => value ? Number(value) : 0 },
    // {
    //   title: "Tổng tiền sau chiết khấu",
    //   dataIndex: "price_discount",
    //   key: "price_discount",
    //   align: "right",
    //   onHeaderCell: () => ({
    //     style: { textAlign: "center" },
    //   }),
    // },
    // {
    //   title: "Lợi nhuận",
    //   dataIndex: "profit",
    //   key: "profit",
    //   align: "right",
    //   onHeaderCell: () => ({
    //     style: { textAlign: "center" },
    //   }),
    //   render: value => value ? Number(value).toLocaleString() : 0,
    // },
    {
      title: "Ngày tạo",
      dataIndex: "created_at", // nhớ đúng key từ API (created_at, không phải create_at)
      key: "created_at",
      render: text => (text ? dayjs(text).format("DD/MM/YYYY") : ""),
      align: "center",
    },
    { title: "Ghi chú", dataIndex: "note", align: "center" },
  ]
  const items = Object.keys(Tabs).map(key => ({
    key,
    label: <div className="text-tile-tabs">{Tabs[key].name}</div>,
  }))
  const handleChangeTab = key => {
    setActiveKey(key)
    setTabStatus(Tabs[key].status)
  }

  const handleTableChange = newPagination => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    })
  }
  const handleOpenDetailModal = record => {
    setSelectedRecord(record)
    setIsDetailModalOpen(true)
  }

  // mở modal seri SIM
  const handleOpenSimModal = record => {
    setSelectedRecord(record)
    setIsSimModalOpen(true)
  }

  const handleCloseModals = () => {
    setIsDetailModalOpen(false)
    setIsSimModalOpen(false)
    setSelectedRecord(null)
  }
  return (
    <div>
      {/* <StyleTabsCustom>
        <TabsCustom
          onChange={handleChangeTab}
          activeKey={activeKey}
          items={items}
          defaultActiveKey="all"
          type="card"
          destroyInactiveTabPane={true}
        />
      </StyleTabsCustom> */}
      <div style={{ display: "flex" }}>
        <FilterCustom
          setFilter={setFilter}
          setKeyword={setKeyword}
        // tabStatus={tabStatus}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "row",
          margin: "10px 0",
          gap: "10px",
        }}
      >
        <div style={{ padding: "0 5px", color: "#007BFF", minWidth: "150px" }}>
          <strong>Tổng số đơn hàng: {pagination.total}</strong>
        </div>
        {/* <div style={{ padding: "0 5px", color: "#28A745", minWidth: "150px" }}>
          <strong>
            Tổng tiền trước chiết khấu: {Number(summary?.sale_price || 0)?.toLocaleString()}
          </strong>
        </div>
        <div style={{ padding: "0 5px", color: "#FF0000", minWidth: "150px" }}>
          <strong>Tổng tiền sau chiết khấu: {Number(summary?.price_discount || 0)?.toLocaleString()}</strong>
        </div>
        <div style={{ color: COLOR_SUMMARY.loi_nhuan }}>
          <strong>Lợi nhuận: {Number(summary?.profit || 0)?.toLocaleString()}</strong>
        </div> */}
        <div style={{ color: "#28A745" }}>
          <strong>Tổng dung lượng: {Number(summary?.total_data_volume_gb || 0)} GB</strong>
        </div>
      </div>
      <TableCustom
        isPrimary
        columns={columns}
        dataSource={dataSource}
        showPagination
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
        }}
        onChange={handleTableChange}
        footerLeft={<div className="d-flex mt-20" />}
        widthScroll={1200}
        textEmpty="Không có dữ liệu!"
        scroll={{ x: "max-content" }}
        loading={loading}
        onRow={(record, rowIndex) => {
          return {
            onClick: event => { setSelectedRecord(record); setIsDetailModalOpen(true) },
          }
        }
        }
      />
      {selectedRecord && (
        <ViewSaleDetailModal
          open={isDetailModalOpen}
          onCancel={handleCloseModals}
          id={selectedRecord.ID}
        />
      )}
      {isSimModalOpen && (
        <ViewSimDetailModal
          visible={isSimModalOpen}
          onClose={handleCloseModals}
          id={selectedRecord?.ID}
          api={ReportsService.detailSimSale}
        />
      )}
    </div>
  )
}

export default ListSale
